import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkflowModelInfos } from '../../../models/workflow/workflowModelInfos';
import { selectWorkflowModelInfosProcess, selectWorkflowModelInfosTask } from '../workflow-model-infos-selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { ProcessDefinitionResponse } from '../../../models/workflow/processDefinitionResponse';
import { Process } from '../../../../entry-routes/flowable/model/process';
import { WkfProcessInstanceService } from '../../../services/workflow/wkf-process-instance-service';
import { WorkflowModelInfosAction } from '../action/workflow-model-infos-action';

@Injectable({
  providedIn: 'root'
})
export class WorkflowModelInfosService {
  private workflowModelInfosProcess$: Observable<WorkflowModelInfos[]> = this.store.select( selectWorkflowModelInfosProcess ).pipe(takeUntilDestroyed());
  private workflowModelInfosProcess: WorkflowModelInfos[] = []
  private workflowModelInfosTask$: Observable<WorkflowModelInfos[]> = this.store.select( selectWorkflowModelInfosTask ).pipe(takeUntilDestroyed());
  private workflowModelInfosTask: WorkflowModelInfos[] = []


  constructor(
              private store : Store,
              private wkfProcessInstanceService: WkfProcessInstanceService,
              private workflowModelInfosAction: WorkflowModelInfosAction
  ) {
    this.workflowModelInfosProcess$.subscribe( (workflowModelInfosProcess) => {
      if(workflowModelInfosProcess?.length>0) {
        this.workflowModelInfosProcess = workflowModelInfosProcess;
      }
    });

    this.workflowModelInfosTask$.subscribe( (workflowModelInfosTask) => {
      if (workflowModelInfosTask?.length>0) {
        this.workflowModelInfosTask = workflowModelInfosTask;
      }
    });

  }

  loadWorkflowModelInfos() {
    if (this.workflowModelInfosProcess.length ===0 ) {
      this.workflowModelInfosAction.loadWorkflowModelInfosProcessStarted();
      this.wkfProcessInstanceService.listProcessDefinitions().subscribe(processDefinitionList => {
        const workflowModelInfosTab  = processDefinitionList.data.map( ( processDefinitionResponse : ProcessDefinitionResponse) => {return  new WorkflowModelInfos(processDefinitionResponse.key,processDefinitionResponse.name); })
        this.workflowModelInfosAction.loadWorkflowModelInfosProcessSucceeded(workflowModelInfosTab);
      });
    }
    if (this.workflowModelInfosTask.length ===0 ) {
      this.workflowModelInfosAction.loadWorkflowModelInfosTaskStarted();
      this.wkfProcessInstanceService.listTasksDefinitions().subscribe( tasksDefinitionList => {
        const workflowModelInfosList: WorkflowModelInfos[] = [];
        const processes: Process[] = tasksDefinitionList['processes'];
        processes.forEach( ( process ) => {
          Object.values( process.flowElementMap ).forEach( ( flowElement ) => {
            let bulkActions : string[] = [];
            let unassignable = false;
            if(!!flowElement.documentation) {
              try {
                  const docJson = JSON.parse(flowElement.documentation)
                  bulkActions = docJson["bulkActions"];
                  unassignable = !!docJson["unassignable"];
                }
              catch(e) {
                console.error("Error parsing flowElement ( activity ? ) documentation ", flowElement.documentation)
              }
            }

            workflowModelInfosList.push( new WorkflowModelInfos( flowElement.id, flowElement.name, bulkActions, unassignable ) );
          } )
        } )
        this.workflowModelInfosAction.loadWorkflowModelInfosTaskSucceeded( workflowModelInfosList );

      } );
    }
  }

  getProcessLabel(key : string ): string {
    let label='';
    const workflowModelInfosTask = this.workflowModelInfosProcess.find( (workflowModelInfos) => workflowModelInfos.key === key)
    label = workflowModelInfosTask?.label;
    return label;
  }

  getTaskLabel(key : string ): string {
    let label='';
    const workflowModelInfosTask = this.workflowModelInfosTask.find( (workflowModelInfos) => workflowModelInfos.key === key)
    label = workflowModelInfosTask?.label;
    return label;
  }

  isTaskUnassignable( activityKey : string ): boolean {
    const workflowModelInfosTask = this.workflowModelInfosTask.find( (workflowModelInfos) => workflowModelInfos.key === activityKey)
    return workflowModelInfosTask?.unassignable === true;
  }

  // renvoi la liste des bulkActions disponible pour la liste d'activités fournie
  getBulkActionsForTasks( activitiesKeys : string[]) : string[] {
    let bulkActions : string[] = [];
    let first = true;
    activitiesKeys.forEach( ( activityKey ) => {
      const workflowModelInfosTask = this.workflowModelInfosTask.find( (workflowModelInfos) => workflowModelInfos.key === activityKey)
      if( workflowModelInfosTask.bulkActions) {
        if ( first ) {
          bulkActions = workflowModelInfosTask.bulkActions
          first = false;
        } else {
          // la liste bulkActions est initialisée avec n elements et n>0 , on regarde si tous les éléments sont dans la nouvelle liste sinon on retire ...
          bulkActions = bulkActions.filter( (bulkAction: string) => workflowModelInfosTask.bulkActions.find( (bulkAction2) => bulkAction2 == bulkAction  ));
        }
      } else {
        bulkActions = [];
        first = false;
      }
    })
    return bulkActions;
  }
}
